<div class="trip-detail-popup-right">
  <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="closeDialog()" />
</div>

<form class="admin-forms" [formGroup]="bidForm">
  <div class="accordion-class">
    <h5>{{ data.mode === 'edit' ? 'Update Your Bid Rate' : 'Submit Your Bid Rate' }}</h5>
    <mat-divider></mat-divider>
    <div class="row mt-3">
      <div class="col-sm-12">
        <div class="floor-prices">
          <div *ngIf="data.price_per_ton">Base Price: <strong>Rs. {{data.price_per_ton | number:'1.2-2'}}</strong></div>
          <div>Current Lowest: 
            <strong>{{ data.lowest_bid_rate ? 'Rs. ' + (data.lowest_bid_rate | number:'1.2-2') : '-' }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="col-sm-5">
          <span>Rate / MT :</span>
        </div>
        <div class="col-sm-7">
          <mat-form-field class="no-error-underline" appearance="fill">
            <input matInput formControlName="rate" placeholder="Enter Rate/MT" (input)="limitDecimalPlaces($event)"
              required />
            <mat-error *ngIf="bidForm.get('rate')?.hasError('required')">
              Rate/MT is required
            </mat-error>
            <mat-error *ngIf="bidForm.get('rate')?.hasError('pattern')">
              Please enter a valid positive integer.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 d-flex align-items-center justify-content-center">

        <button type="button" class="button buttonCancel my-3" *ngIf="data.mode === 'add'"
          [ngClass]="{ 'button-disabled': !bidForm.valid || isLoading }" [disabled]="!bidForm.valid || isLoading"
          (click)="submitBid()">
          <ng-container *ngIf="!isLoading">SUBMIT BID</ng-container>
          <ng-container *ngIf="isLoading">
            <span class="loader"></span>
          </ng-container>
        </button>

        <button type="button" class="button buttonCancel my-3" *ngIf="data.mode === 'edit'"
          [ngClass]="{ 'button-disabled': !bidForm.valid || isLoading }" [disabled]="!bidForm.valid || isLoading"
          (click)="resubmitBid()">
          <ng-container *ngIf="!isLoading">RESUBMIT BID</ng-container>
          <ng-container *ngIf="isLoading">
            <span class="loader"></span>
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</form>